module.exports = __webpack_public_path__ + "static/media/slika5.f56000f7.png";